(() => {
  const root = window.Shopify?.routes?.root || '/';
  const strings = JSON.parse(document.getElementById('NxStrings')?.textContent || '{}');
  const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' }).format(cents / 100);
  const showDialog = (dialog, trigger) => {
    if (!dialog) return;
    document.querySelectorAll('dialog[open]').forEach((open) => open.close());
    dialog.returnTrigger = trigger || document.activeElement;
    if (!dialog.open) dialog.showModal();
  };
  document.addEventListener('click', (event) => {
    const open = event.target.closest('[data-dialog-open]');
    if (open) {
      showDialog(document.getElementById(open.dataset.dialogOpen), open);
      return;
    }
    const close = event.target.closest('[data-dialog-close]');
    if (close) close.closest('dialog')?.close();
    const zoom = event.target.closest('.lux-product__media');
    if (zoom && zoom.querySelector('img')) {
      const source = zoom.querySelector('img');
      const dialog = document.getElementById('NxZoom');
      const target = dialog.querySelector('img');
      target.src = source.currentSrc || source.src;
      target.alt = source.alt;
      showDialog(dialog, zoom);
    }
  });
  document.querySelectorAll('.nx-drawer, .nx-quick-dialog, .nx-zoom-dialog').forEach((dialog) => {
    dialog.addEventListener('click', (event) => {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => {
      const trigger = dialog.returnTrigger;
      if (trigger?.isConnected && !trigger.closest('dialog:not([open])')) trigger.focus();
    });
  });
  document.querySelectorAll('.nx-mega').forEach((details) => {
    details.addEventListener('toggle', () => {
      if (details.open) document.querySelectorAll('.nx-mega[open]').forEach((other) => { if (other !== details) other.open = false; });
    });
    details.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') { details.open = false; details.querySelector('summary').focus(); }
    });
  });
  document.addEventListener('click', (event) => {
    if (!event.target.closest('.nx-mega')) document.querySelectorAll('.nx-mega[open]').forEach((details) => { details.open = false; });
  });
  const initTabs = (container) => {
    if (container.dataset.ready) return;
    container.dataset.ready = 'true';
    const tabs = [...container.querySelectorAll('[role=tab]')];
    const activate = (tab) => {
      tabs.forEach((item) => {
        const selected = item === tab;
        item.setAttribute('aria-selected', String(selected));
        item.tabIndex = selected ? 0 : -1;
        container.querySelector(`#${CSS.escape(item.getAttribute('aria-controls'))}`).hidden = !selected;
      });
    };
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(tab));
      tab.addEventListener('keydown', (event) => {
        let next;
        if (event.key === 'ArrowRight') next = tabs[(index + 1) % tabs.length];
        if (event.key === 'ArrowLeft') next = tabs[(index - 1 + tabs.length) % tabs.length];
        if (event.key === 'Home') next = tabs[0];
        if (event.key === 'End') next = tabs[tabs.length - 1];
        if (next) { event.preventDefault(); activate(next); next.focus(); }
      });
    });
  };
  document.querySelectorAll('[data-product-tabs]').forEach(initTabs);
  document.addEventListener('shopify:section:load', (event) => { event.target.querySelectorAll('[data-product-tabs]').forEach(initTabs); });
  const searchInput = document.querySelector('[data-predictive-input]');
  const searchResults = document.querySelector('[data-predictive-results]');
  const searchStatus = document.querySelector('[data-search-status]');
  const discovery = document.querySelector('[data-search-discovery]');
  let searchTimer, searchController;
  searchInput?.addEventListener('input', () => {
    clearTimeout(searchTimer);
    searchController?.abort();
    const query = searchInput.value.trim();
    searchResults.replaceChildren();
    searchStatus.textContent = '';
    discovery.hidden = !!query;
    if (!query) return;
    searchStatus.textContent = strings.loading;
    searchTimer = setTimeout(async () => {
      searchController = new AbortController();
      try {
        const url = new URL(`${root}search/suggest.json`, location.origin);
        url.searchParams.set('q', query);
        url.searchParams.set('resources[type]', 'product');
        url.searchParams.set('resources[limit]', '6');
        const response = await fetch(url, { signal: searchController.signal });
        if (!response.ok) throw new Error();
        const data = await response.json();
        if (query !== searchInput.value.trim()) return;
        const products = data.resources?.results?.products || [];
        searchStatus.textContent = products.length ? `${products.length} ${strings.search_results.toLowerCase()}` : strings.search_empty;
        products.forEach((product) => {
          const link = document.createElement('a'); link.className = 'nx-predictive-item'; link.href = product.url;
          const img = document.createElement('img'); img.src = product.featured_image?.url || product.image; img.alt = ''; img.width = 80; img.height = 90;
          const info = document.createElement('div');
          const vendor = document.createElement('small'); vendor.textContent = product.vendor;
          const title = document.createElement('p'); title.textContent = product.title;
          const price = document.createElement('strong'); price.textContent = new Intl.NumberFormat(document.documentElement.lang, { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' }).format(Number(product.price));
          info.append(vendor, title, price); link.append(img, info); searchResults.append(link);
        });
      } catch (error) { if (error.name !== 'AbortError') searchStatus.textContent = strings.search_error; }
    }, 220);
  });
  const quickDialog = document.getElementById('NxQuick');
  let quickController;
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-quick-url]');
    if (!button) return;
    const content = quickDialog.querySelector('[data-quick-content]');
    const status = quickDialog.querySelector('[data-quick-status]');
    content.replaceChildren(); status.textContent = strings.loading;
    showDialog(quickDialog, button);
    quickController?.abort(); quickController = new AbortController();
    try {
      const response = await fetch(`${new URL(button.dataset.quickUrl, location.origin).pathname}.js`, { signal: quickController.signal });
      if (!response.ok) throw new Error(strings.add_error);
      const product = await response.json();
      const box = document.createElement('div'); box.className = 'nx-quick-layout';
      const img = document.createElement('img'); img.src = product.featured_image; img.alt = product.title; img.width = 400; img.height = 400;
      const form = document.createElement('form'); form.action = `${root}cart/add`; form.method = 'post';
      const vendor = document.createElement('p'); vendor.className = 'nx-overline'; vendor.textContent = product.vendor;
      const title = document.createElement('h3'); title.textContent = product.title.replace(`${product.vendor} - `, '');
      const price = document.createElement('p'); price.textContent = money(product.price);
      const select = document.createElement('select'); select.name = 'id'; select.required = true; select.setAttribute('aria-label', strings.choose_option);
      const empty = new Option(strings.choose_option, ''); empty.disabled = true; empty.selected = true; select.add(empty);
      product.variants.forEach((variant) => { const option = new Option(`${variant.title} — ${money(variant.price)}${variant.available ? '' : ` / ${strings.sold_out}`}`, variant.id); option.disabled = !variant.available; select.add(option); });
      const submit = document.createElement('button'); submit.type = 'submit'; submit.className = 'nx-button nx-button-dark'; submit.textContent = strings.choose_option; submit.disabled = true;
      const link = document.createElement('a'); link.href = product.url; link.textContent = strings.view_details;
      select.addEventListener('change', () => { const selected = product.variants.find((v) => String(v.id) === select.value); submit.disabled = !selected?.available; submit.textContent = strings.add_bag; if (selected) { price.textContent = money(selected.price); if (selected.featured_image?.src) img.src = selected.featured_image.src; } });
      form.append(vendor, title, price, select, submit, link); box.append(img, form); content.append(box); status.textContent = '';
      if (product.variants.length === 1 && product.variants[0].title === 'Default Title' && product.variants[0].available) { select.value = String(product.variants[0].id); select.dispatchEvent(new Event('change')); }
      form.addEventListener('submit', async (e) => {
        e.preventDefault(); if (submit.disabled) return;
        submit.disabled = true; status.textContent = strings.loading; let added = false;
        try {
          const response = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
          const data = await response.json(); if (!response.ok) throw new Error(data.description || strings.add_error);
          added = true; quickDialog.close();
          await document.querySelector('lux-cart-drawer').refresh(true, button);
        } catch (error) {
          if (added) { location.href = `${root}cart`; return; }
          status.textContent = error.message; submit.disabled = false;
        }
      });
      select.focus();
    } catch (error) { if (error.name !== 'AbortError') status.textContent = error.message; }
  });
  document.querySelectorAll('.lux-product__media').forEach((media) => {
    media.tabIndex = 0; media.setAttribute('role', 'button'); media.setAttribute('aria-label', strings.zoom);
    media.addEventListener('keydown', (event) => { if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); media.click(); } });
  });
})();
